import { getBoundaryCoordinates } from "../services/v2/wantAdService";
import { useState, useEffect } from "react";
import _ from "lodash";

const usePolygons = (zipCode, disable = true) => {
  const [polygonCoordinates, setPolygonCoordinates] = useState([]);

  const setBoundaryCoordinates = (zipCode) => {
    if (_.isEmpty(zipCode)) return;

    var payload = [];
    zipCode?.map(function (item) {
      payload.push(item?.zipCode);
    });

    getBoundaryCoordinates({ zipCode: payload })
      .then((response) => {
        const responseResult = _.get(response, "result", null);

        if (response.errorCode === 0 && responseResult) {
          let coordinates = [];
          let zipValues = [];
          responseResult.map((result) => {
            zipValues.push({ zipCode: result?.ZipCode, zipId: result?.ZipId });

            coordinates.push([result?.coordinates]);
          });
          setPolygonCoordinates(coordinates);
        } else {
          console.log("Something went wrong");
        }
      })
      .catch((err) => {
        console.log("Error", err);
      });
  };

  useEffect(() => {
    if (!disable) {
      setBoundaryCoordinates(zipCode);
    }
  }, [zipCode, disable]);

  return { polygonCoordinates };
};

export default usePolygons;
